// Auto-generated normalizer for table: CAR_BOOKING.Reserva
export function reservaNormalize(row) {
  return {
    idReserva: row.idReserva ?? row.IdReserva ?? row['idReserva'] ?? 0,
    idSolicitante: row.idSolicitante ?? row.IdSolicitante ?? row['idSolicitante'] ?? 0,
    idChofer: row.idChofer ?? row.IdChofer ?? row['idChofer'] ?? 0,
    idVehiculo: row.idVehiculo ?? row.IdVehiculo ?? row['idVehiculo'] ?? 0,
    idDireccionInicio: row.idDireccionInicio ?? row.IdDireccionInicio ?? row['idDireccionInicio'] ?? 0,
    idDireccionDestino: row.idDireccionDestino ?? row.IdDireccionDestino ?? row['idDireccionDestino'] ?? 0,
    fechaInicio: row.fechaInicio ?? row.FechaInicio ?? row['fechainicio'] ?? null,
    fechaFin: row.fechaFin ?? row.FechaFin ?? row['fechafin'] ?? null,
    horaInicio: row.horaInicio ?? row.HoraInicio ?? row['horainicio'] ?? '',
    horaFin: row.horaFin ?? row.HoraFin ?? row['horafin'] ?? '',
    origenTexto: row.origenTexto ?? row.OrigenTexto ?? row['origenTexto'] ?? '',
    destinoTexto: row.destinoTexto ?? row.DestinoTexto ?? row['destinoTexto'] ?? '',
    motivo: row.motivo ?? row.Motivo ?? row['motivo'] ?? '',
    idEstadoReserva: row.idEstadoReserva ?? row.IdEstadoReserva ?? row['idEstadoReserva'] ?? 0,
    fueraHorarioMin: row.fueraHorarioMin ?? row.FueraHorarioMin ?? row['fueraHorarioMin'] ?? '',
    observaciones: row.observaciones ?? row.Observaciones ?? row['observaciones'] ?? '',
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
    idTipoAprobacion: row.idTipoAprobacion ?? row.IdTipoAprobacion ?? row['idTipoAprobacion'] ?? 0,
  };
}